"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCommentSchema = exports.softDeleteCommentSchema = exports.updateCommentSchema = exports.moderateCommentSchema = exports.CommentRequestDTOSchema = exports.CommentDTO = exports.CommentSchema = exports.CommentBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var forumModeration_1 = require("./lib/forumModeration");
var forumComments_1 = require("./lib/forumComments");
var Like_1 = require("./Like");
var Post_1 = require("./Post");
var User_1 = require("./User");
exports.CommentBaseSchema = zod_1.z.object({
    comment: zod_1.z.string(),
    likes: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    post: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    author: zod_1.z.instanceof(ObjectId_1.ObjectId),
    parentCommentId: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    editedAt: zod_1.z.coerce.date().optional(),
    deletedAt: zod_1.z.coerce.date().optional(),
    reasonForModeration: zod_1.z.string().optional(),
    moderationReasonCode: zod_1.z.enum(forumModeration_1.FORUM_MODERATION_REASON_CODES).optional(),
    moderator: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
});
exports.CommentSchema = exports.CommentBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var CommentDTOSchema = exports.CommentSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.CommentDTO = {
    convertFromModel: function (model) {
        var _a, _b;
        var rawLikes = model.likes;
        var likes = Array.isArray(rawLikes)
            ? (0, ObjectId_1.isArrayPopulated)(rawLikes)
                ? rawLikes.filter(Boolean).map(function (like) { return Like_1.LikeDTO.convertFromModel(like); })
                : rawLikes.filter(Boolean).map(function (like) { return like.toString(); })
            : [];
        var softDeleted = (0, forumComments_1.isCommentSoftDeleted)(model);
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            comment: softDeleted ? '' : model.comment,
            likes: likes,
            author: (0, ObjectId_1.isPopulated)(model.author) ? User_1.UserDTO.convertFromModel(model.author) : model.author.toString(),
            post: (0, ObjectId_1.isPopulated)(model.post) ? Post_1.PostDTO.convertFromModel(model.post) : (_a = model.post) === null || _a === void 0 ? void 0 : _a.toString(),
            parentCommentId: model.parentCommentId ? model.parentCommentId.toString() : undefined,
            editedAt: model.editedAt,
            deletedAt: model.deletedAt,
            moderator: (0, ObjectId_1.isPopulated)(model.moderator)
                ? User_1.UserDTO.convertFromModel(model.moderator)
                : (_b = model.moderator) === null || _b === void 0 ? void 0 : _b.toString(),
            reasonForModeration: model.reasonForModeration,
            moderationReasonCode: model.moderationReasonCode,
        };
        return dto;
    },
};
exports.CommentRequestDTOSchema = CommentDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { author: (0, ObjectId_1.ObjectIdString)('Invalid author id').optional(), post: (0, ObjectId_1.ObjectIdString)('Invalid post id'), moderator: (0, ObjectId_1.ObjectIdString)('Invalid moderator id'), likes: CommentDTOSchema.shape.likes.optional() }));
exports.moderateCommentSchema = zod_1.z
    .object({
    commentId: zod_1.z.string(),
    reasonCode: zod_1.z.enum(forumModeration_1.FORUM_MODERATION_REASON_CODES),
    otherReason: zod_1.z.string().trim().max(forumModeration_1.FORUM_MODERATION_OTHER_MAX).optional(),
})
    .superRefine(function (data, ctx) {
    var _a, _b;
    if (data.reasonCode !== 'other')
        return;
    var note = (_b = (_a = data.otherReason) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
    if (note.length < forumModeration_1.FORUM_MODERATION_OTHER_MIN) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['otherReason'],
            message: 'Please add a short public reason',
        });
    }
});
exports.updateCommentSchema = zod_1.z.object({
    commentId: zod_1.z.string(),
    comment: zod_1.z.string().trim().min(1),
});
exports.softDeleteCommentSchema = zod_1.z.object({
    commentId: zod_1.z.string(),
});
exports.createCommentSchema = zod_1.z.object({
    comment: zod_1.z.string().trim().min(1),
    postId: zod_1.z.string(),
    parentCommentId: zod_1.z.string().optional(),
});
//# sourceMappingURL=Comment.js.map